import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ModuloResponse, ModuloService } from '../../../services/modulo/modulo.service';

@Component({
  selector: 'app-gerenciar-modulos',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './gerenciar-modulos.html',
  styleUrl: './gerenciar-modulos.scss',
})
export class GerenciarModulos implements OnInit {
  modulos: ModuloResponse[] = [];
  isLoading = false;
  erro: string | null = null;

  constructor(
    private moduloService: ModuloService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.carregarModulos();
  }

  async carregarModulos(): Promise<void> {
    this.isLoading = true;
    this.erro = null;

    try {
      this.modulos = await this.moduloService.listarTodos();
    } catch (err) {
      console.error('Erro ao carregar módulos:', err);
      this.erro = 'Não foi possível carregar os módulos. Tente novamente.';
    } finally {
      this.isLoading = false;
    }
  }

  editarModulo(modulo: ModuloResponse): void {
    this.router.navigate(['/modulos', modulo.idModulo, 'editar']);
  }
}